import React, { createContext, useContext, useEffect, useState } from "react";
import { getUserById } from "../services/UsersService";
import { getUserId } from "../services/authService";

export interface APIUser {
  id?: string | number;
  name?: string;
  email?: string;
  mobile?: string;
  country_code?: string;
  banner?: string;
  [key: string]: any;
}

type UserContextType = {
  user: APIUser | null;
  setUser: React.Dispatch<React.SetStateAction<APIUser | null>>;
  refreshUser: () => Promise<void>;
};

const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUser = (): UserContextType => {
  const ctx = useContext(UserContext);
  if (!ctx) {
    throw new Error("useUser must be used within a UserProvider");
  }
  return ctx;
};

export const UserProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [user, setUser] = useState<APIUser | null>(null);

  const refreshUser = async () => {
    try {
      const userId = getUserId();
      if (!userId) return;
      const resp = await getUserById(userId);
      if (resp && resp.user) {
        setUser(resp.user);
      }
    } catch (error) {
      // ignore for now
      console.error("refreshUser error", error);
    }
  };

  useEffect(() => {
    // Fetch user once when provider mounts
    refreshUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UserContext.Provider value={{ user, setUser, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
